export default __webpack_public_path__ + "static/media/eth-black.72cb6b75.svg";